import { Form }                from 'antd';
import FormattedMessageWrapper from './FormattedMessageWrapper';

interface FormItemProps {
  children: any;
  initialValue?: any;
  label?: any;
  name: string;
  otherProps?: any;
  required?: boolean;
  requiredMessage?: string;
  rules?: any[];
}

const FormItem = ({
  children,
  label,
  name,
  otherProps = {},
  required = true,
  requiredMessage,
  rules = [],
}: FormItemProps) => {
  const allRules = [...rules];

  if (required) {
    allRules.push({
      message: requiredMessage ? (
        <FormattedMessageWrapper id={requiredMessage} />
      ) : (
        <FormattedMessageWrapper id="Information manquante" />
      ),
      required: true,
    });
  }

  return (
    <Form.Item
      // help={getFieldError(name) || ''}
      label={typeof label === 'string' ? <FormattedMessageWrapper id={label} /> : label}
      labelCol={{ span: 24 }}
      name={name}
      rules={allRules}
      // validateStatus={getFieldError(name) ? 'error' : ''}
      {...otherProps}
    >
      {children}
    </Form.Item>
  );
};

export default FormItem;
